<template>
  <div class="section-main__warp roleManage-page">
    <ioc-table
      v-show="!showDialog"
      ref="crud"
      :data="accountGroupList"
      :option="option"
      :page="page"
      @selection-change="handleSelectionChange"
      @search-change="query"
      @search-reset="reset"
      @size-change="sizeChange"
      @current-change="pageChange"
    >
      <template slot="menuLeft">
        <el-button
          v-auth="'/accountgroup:add'"
          type="primary"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="openEditDialog"
        >
          {{ $t("accountGroup.button.add") }}
        </el-button>
        <el-button
          v-auth="'/accountgroup:delete'"
          type="primary"
          class="iss-operation-button"
          icon="el-icon-delete"
          @click="deleteBatch"
        >
          {{ $t("accountGroup.button.batchDel") }}
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('accountGroup.button.relation')"
          placement="top-start"
        >
          <el-button
            type="text"
            v-auth="'/accountgroup:addAccount'"
            icon="iconfont icon-Link pointer"
            @click="openAccountDialog(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('accountGroup.button.edit')"
          placement="top-start"
        >
          <el-button
            type="text"
            v-auth="'/accountgroup:update'"
            icon="iconfont icon-xiugai pointer"
            @click="openEditDialog(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('accountGroup.button.delete')"
          placement="top-start"
        >
          <el-button
            type="text"
            v-if="scope.row.dataType != 0"
            v-auth="'/accountgroup:delete'"
            icon="el-icon-delete pointer"
            @click="deleteRow(scope.row)"
          ></el-button
          >&nbsp;&nbsp;&nbsp;&nbsp;
        </el-tooltip>
      </template>
    </ioc-table>
    <!--新建角色-->
    <addRole
      v-show="showDialog"
      ref="refAppRole"
      :treeData="menusData"
      :showType="showType"
      @cancelForm="cancelAddRole"
      @submitForm="submitAddRole"
    >
    </addRole>
    <!-- 关联用户 -->
    <appPanel
      :width="870"
      class="app-panel"
      :isExpand="setAccountVisible"
      @cancel="close"
      :title="$t('accountGroup.title.relations')"
    >
      <IocTransfer
        :subTitleText="'账户'"
        :data="accounts"
        class="app-panel__iocTransfer"
        v-model="accountChecked"
        @changeData="changeData"
        :props="transferProps"
        type="date"
        :titles="[
          $t('accountGroup.title.selectableAccount'),
          $t('accountGroup.title.selectedAccount')
        ]"
      ></IocTransfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close" :loading="btnLoading">{{
          btnLoading ? "提交中" : $t("accountGroup.button.cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click="handleSetAccount"
          :loading="btnLoading"
          >{{
            btnLoading ? "提交中" : $t("accountGroup.button.save")
          }}</el-button
        >
      </span>
    </appPanel>
  </div>
</template>
<script>
import utils from "@src/common/utils"; //11
import API from "./api/api";
import addRole from "./components/addRole";
import tableOption from "./const/roleTable";
import appPanel from "@src/components/business/app-panel/index";
import IocTransfer from "@src/components/common/ioc-component/ioc-transfer";
export default {
  name: "Role",
  components: {
    IocTransfer,
    appPanel,
    addRole
  },
  data() {
    return {
      btnLoading: false,
      page: {
        pageNo: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      queryForm: {},
      option: tableOption(this),
      accountGroupSetName: "",
      accountGroupSetCode: "",
      setAccountVisible: false,
      accountChecked: [],
      accountList: [],
      accounts: [],
      showType: "",
      dialogTitle: "",
      transferProps: {
        key: "nickName",
        label: "accountNumber"
      },
      accountGroupList: [],
      showDialog: false,
      arouf: [],
      types: [],
      refreshCallBack: (self, res) => {
        self.accountGroupList = res.returnObj.list;
        self.page.total = res.returnObj.total;
      },
      menusData: [],

      ids: [],
      formLabelWidth: "80px"
    };
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      this.queryAccountGroupList();
      this.queryMenu();
      API.queryAccout().then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        res.returnObj.map((item) => {
          // 过滤掉未启用的
          if (item.status !== 2) {
            this.accounts.push(item);
            // this.accounts.push({
            //   key: item.accountNumber,
            //   label: item.accountNumber
            // })
          }
        });
      });
    },
    queryMenu() {
      // 根据账户查询菜单
      this.$fetch(API.queryMenu, {
        accountNumber: utils.Cache.get("CACHE_USER_INFO").account
      }).then((response) => {
        if (response.success && response.returnObj) {
          this.menusData = response.returnObj.map((item) => {
            if (item.menuCode == "01") {
              item.disabled = true;
            }
            return item;
          });
        }
      });
    },
    cancelAddRole() {
      this.showDialog = false;
    },
    submitAddRole() {
      this.showDialog = false;
      this.queryAccountGroupList();
    },
    queryAccountGroupList() {
      const params = Object.assign(
        {
          // flag: "1", // '1':查不到自己的角色，其他值为全部
          flag: "0",
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize
        },
        this.queryForm
      );

      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$fetch("/cms/accountGroup/queryResultsByPage.json", params).then(
        (response) => {
          setTimeout(() => {
            loading.close();
          }, 500);
          this.accountGroupList = response.returnObj.list;
          this.page.total = response.returnObj.total;
        }
      );
    },
    changeData(data) {
      // console.log("data", data);
      this.accountList = data.map((item) => {
        return {
          accountNumber: item.accountNumber,
          beginTime: item.date
            ? this.$utils.Dates.format(item.date[0], "yyyy-MM-dd") + " 00:00:00"
            : "",
          endTime: item.date
            ? this.$utils.Dates.format(item.date[1], "yyyy-MM-dd") + " 23:59:59"
            : ""
          // date: [this.$utils.Dates.format(item.date[0], 'yyyy-MM-dd '), this.$utils.Dates.format(item.date[1], 'yyyy-MM-dd ')]
        };
      });
      // console.log(this.accountList);
    },
    handleSetAccount() {
      const params = {
        code: this.accountGroupSetCode,
        codeList: this.accountList
      };
      this.btnLoading = true;
      this.$fetch(API.insertRelationForAccount, params).then((res) => {
        this.btnLoading = false;
        console.log("ressss", res);
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.$message.success(this.$t("accountGroup.message.setSuccess"));
        this.setAccountVisible = false;
      });
      this.types = [];
    },
    openAccountDialog(row) {
      this.accountGroupSetCode = row.accountGroupCode;
      this.accountGroupSetName = row.accountGroupName;
      this.$fetch(API.queryAccountByAccountGroup, {
        accountGroupCode: row.accountGroupCode
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.setAccountVisible = true;
        this.$nextTick(() => {
          const filteredAccountChecked = res.returnObj.filter(
            (item) => item.status !== 2
          );
          this.accountChecked = filteredAccountChecked;
          console.log("已关联用户列表", this.accountChecked);
        });
      });
    },
    query(param) {
      this.page.pageNo = 1;
      this.queryForm = Object.assign({}, param);
      this.queryAccountGroupList();
    },
    reset() {
      this.queryForm = {};
      this.page.pageSize = 10;
      this.queryAccountGroupList();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.queryAccountGroupList();
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.queryAccountGroupList();
    },
    /**
     * 批量删除账户组
     */
    deleteBatch() {
      const self = this;
      if (self.multipleSelection && self.multipleSelection.length > 0) {
        self
          .$confirm(self.$t("accountGroup.message.batchDeltips"), "删除确认", {
            confirmButtonText: self.$t("accountGroup.button.confirm"),
            cancelButtonText: self.$t("accountGroup.button.cancel"),
            type: "warning"
          })
          .then(() => {
            const accountGroupCodes = [];
            self.multipleSelection.forEach((item) => {
              accountGroupCodes.push(item.accountGroupCode);
            });
            const param = {};
            param.accountGroupCodes = accountGroupCodes;
            self
              .$fetch("/cms/accountGroup/batchDelete.json", param)
              .then((response) => {
                // 删除成功
                if (response.success) {
                  self.queryAccountGroupList();
                  self.$message({
                    type: "success",
                    message: self.$t("accountGroup.message.batchDel")
                  });
                } else {
                  self.$message.error(response.msgContent);
                }
              });
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        self.$message({
          type: "warning",
          message: self.$t("accountGroup.message.selecttips")
        });
      }
    },
    /**
     * 打开新建&编辑账户组Dialog
     * @param row
     */
    openEditDialog(row) {
      this.showDialog = true;
      this.$nextTick(() => {
        if (row.accountGroupCode) {
          this.$refs.refAppRole.form = {
            accountGroupName: row.accountGroupName,
            accountGroupCode: row.accountGroupCode,
            desc: row.desc
          };
          this.showType = "edit";
          this.rowClick(row);
        } else {
          this.showType = "add";
        }
      });
    },
    rowClick(row) {
      this.ids.length = 0;
      // 根据账户组名称查询菜单列表
      this.$fetch(API.queryMenuGroup, {
        accountGroupCode: row.accountGroupCode
      }).then((response) => {
        if (!response.returnObj) {
          return;
        } else {
          this.menusDataMatch(response.returnObj);
          this.$refs.refAppRole.$refs.tree.setCheckedKeys(this.ids);
        }
      });
    },
    menusDataMatch(data) {
      if (!(data instanceof Array) || data === undefined || data === null) {
        return null;
      }
      data.forEach((item) => {
        if (item.childrens) {
          this.menusDataMatch(item.childrens);
        } else {
          this.ids.push(item.menuCode);
        }
      });
    },
    /**
     * 删除指定的账户组
     * @param row
     */
    deleteRow(row) {
      this.$confirm(this.$t("accountGroup.message.deltips"), "删除确认", {
        confirmButtonText: this.$t("accountGroup.button.confirm"),
        cancelButtonText: this.$t("accountGroup.button.cancel"),
        type: "warning",
        cancelButtonClass: "cancel-button-css"
      })
        .then(() => {
          const param = {};
          param.accountGroupCode = row.accountGroupCode;
          this.$fetch("/cms/accountGroup/delete.json", param).then(
            (response) => {
              if (response.success) {
                this.$message({
                  type: "success",
                  message: this.$t("accountGroup.message.delSuccess")
                });
                this.queryAccountGroupList();
              } else {
                this.$message({
                  type: "error",
                  message: response.msgContent
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    handleSelectionChange(selected) {
      this.multipleSelection = selected;
    },
    close() {
      this.setAccountVisible = false;
      this.types = [];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
:deep .el-tree-node__content {
  padding-left: 16px;
}
.roleManage-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  .el-input {
    width: 250px;
  }

  .page-comp {
    margin: 10px 0;
  }

  .roleManage-page-search .el-input {
    padding-left: 15px;
  }
  .roleManage-page-operator {
    text-align: left;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .roleManage-page-search {
    margin: 15px 0;
    text-align: left;
  }
  .roleManage-page-search .el-input__inner {
    margin-left: 15px;
  }
  i {
    cursor: pointer;
  }
  // .el-form .el-input {
  //   width: 100%;
  // }
  .query-btn {
    margin-left: 50px;
  }
  .dialog-footer {
    text-align: right;
  }
  .role-list-scroll {
    flex: 1;
  }
}
.app-panel {
  &__iocTransfer {
    margin: 24px !important;
    height: calc(100% - 48px);
  }
}
</style>
